@if (service.loading()) {
  <div class="tt-guideline-review-update-dialog_spinner">
    <tt-spinner [size]="40" />
  </div>
} @else {
  <tt-drawer-container>
    <tt-drawer class="tt-guideline-review-update-dialog_nav" ttDrawerLeft [minWidth]="300" [opened]="true" [resizable]="true">
      <shared-chapters-tree [readonly]="true" />
    </tt-drawer>
    <tt-drawer-content cdkScrollable class="tt-guideline-review-update-dialog_container">
      <smartbook-content class="tt-guideline-review-update-dialog_content" />
    </tt-drawer-content>
  </tt-drawer-container>

  <tt-guideline-review-update-footer
    [mode]="data.mode"
    [version]="guidelineData().version"
    (closeButtonClicked)="dialogRef.close()"
    (publishButtonClicked)="handlePublishButtonClicked()" />
}
